import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-spreadsheet-guide",
    element: <Navigate to="/guide/what-is-allchinabuy-spreadsheet" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;